<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header primary" style="padding-top: 82px;" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutAlign.gt-xs="space-between center">

            <div class="mat-display-1 my-0 my-sm-42 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'ROUTE_TRACKING' | translate}}</span>
            </div>

            <div fxLayout="row wrap" fxLayoutGap="10px grid" fxLayoutGap.gt-sm="20px grid">
                <div fxFlex="calc(100 - 10px)" fxFlex.gt-sm="calc(25 - 20px)" fxLayout="column" fxLayoutAlign="center center">
                    <span class="h3 font-weight-600">Tahmini km</span>
                    <span>{{(totalDistance/1000)| number : '1.2-2'}} km</span>
                </div>
                <div fxFlex="calc(100 - 10px)" fxFlex.gt-sm="calc(25 - 20px)" fxLayout="column" fxLayoutAlign="center center">
                    <span class="h3 font-weight-600">Tahmini Süre</span>
                    <span>{{totalDuration | dayHourMinute}}</span>
                </div>
                <div fxFlex="calc(100 - 10px)" fxFlex.gt-sm="calc(25 - 20px)" fxLayout="column" fxLayoutAlign="center center">
                    <span class="h3 font-weight-600">Toplam Konteyner</span>
                    <span>{{totalContainer}}</span>
                </div>
                <div fxFlex="calc(100 - 10px)" fxFlex.gt-sm="calc(25 - 20px)" fxLayout="column" fxLayoutAlign="center center">
                    <span class="h3 font-weight-600">Boş Konteyner</span>
                    <span>{{totalEmptyContainer}}</span>
                </div>
                <div fxFlex="calc(100 - 10px)" fxFlex.gt-sm="calc(25 - 20px)" fxLayout="column" fxLayoutAlign="center center">
                    <span class="h3 font-weight-600">Dolu Konteyner</span>
                    <span>{{totalFullContainer}}</span>
                </div>

            </div>
        </div>
        <!-- / HEADER -->
        <div [hidden]="car == null" class="content-card  my-20">
            <div class="map-container">
                <div *ngIf="shiftControl" class="map-frame">
                    <div id="map">
                        <div mat-dialog-actions align="end">
                            <button matTooltip="{{'FINISH_THE_RIDE'|translate}}" style="z-index: 99999; display: none;" mat-raised-button class="finishBtn m-20"
                                (click)="onFinishControlClick()">
                                <mat-icon>outlined_flag</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height:100%" fxLayout="column" fxLayoutAlign="center center" *ngIf="this.polygon==null">
                <h1>{{'THER_IS_NO_DEFINED_REGION'|translate}}</h1>
            </div>
            <div *ngIf="this.polygon!=null" style="height: 100%; width:100%">
                <div style="height:100%" fxLayout="column" fxLayoutAlign="center center"
                    *ngIf="shiftList.length==0 && this.selectedShift===undefined">
                    <h1>{{'NO_DEFINED_SHIFT'|translate}}</h1>
                    <button mat-raised-button type="button"
                        (click)="this.selectedShift=null;setMap()">{{'NO_SHIFT'|translate}}</button>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="height: 100%;"
                    *ngIf="!shiftControl && shiftList.length!=0">
                    <div class="w-30-p">
                        <h3>{{'DRIVER_MAP_SHIFT_DESCRIPTION'|translate}}</h3>
                    </div>
                    <mat-form-field appearance="outline" floatLabel="always" class="w-30-p">
                        <mat-label>{{'SELECT_SHIFT'|translate}}</mat-label>
                        <mat-select [(ngModel)]="selectedShift" required name="companies">
                            <mat-option *ngFor="let item of shiftList" [value]="item.id">
                                {{item.description}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="w-30-p" fxLayout="row" fxLayoutAlign="space-between center">
                        <button mat-raised-button type="button" (click)="setMap()">{{'APPROVE'|translate}}</button>
                        <button mat-raised-button type="button"
                            (click)="this.selectedShift=null;setMap()">{{'NO_SHIFT'|translate}}</button>
                    </div>
                </div>
            </div>

        </div>
        <div>
        </div>
    </div>
    <!-- / CENTER -->
</div>